<nav class="admin-nav" #nav
    [class.scrolled-start]="scrolledStart"
    [class.scrolled-end]="scrolledEnd"
    (scroll)="onScroll()">
    <!-- Dashboard first: admins and sales. -->
    @if (canAccessOrders) {
        <!-- exact match so Overview doesn't stay active on /dashboard/orders -->
        <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">{{ 'dashboard_nav_overview' | translate }}</a>
        <a routerLink="/dashboard/orders" routerLinkActive="active">{{ 'dashboard_nav_orders' | translate }}</a>
    }
    <!-- Messages is admin-only: canAccessOrders covers the overview and orders,
         not the contact inbox. -->
    @if (isAdmin) {
        <a routerLink="/dashboard/messages" routerLinkActive="active">{{ 'dashboard_nav_messages' | translate }}</a>

        <!-- Administration after it. -->
        <a routerLink="/gateways" routerLinkActive="active">{{ 'dashboard_nav_admin_gateways' | translate }}</a>
        <a routerLink="/users" routerLinkActive="active">{{ 'dashboard_nav_users' | translate }}</a>
        <a routerLink="/files" routerLinkActive="active">{{ 'dashboard_nav_files' | translate }}</a>
        <a routerLink="/categories" routerLinkActive="active">{{ 'dashboard_nav_categories' | translate }}</a>
        <a routerLink="/equipment-management" routerLinkActive="active">{{ 'dashboard_nav_equipment' | translate }}</a>
        <a routerLink="/projects-management" routerLinkActive="active">{{ 'dashboard_nav_projects' | translate }}</a>
    }

    <!-- Local file-portal user: their own files, never Gateways — matches the
         legacy usr/main.php menu. -->
    @if (isFilePortalUser) {
        <a routerLink="/my-files" routerLinkActive="active">{{ 'dashboard_nav_files' | translate }}</a>
    }

    <!-- Cloud gateway customer: Gateways, never Files — matches the legacy
         usr/main_gw.php menu. -->
    @if (isCloudCustomer) {
        <a routerLink="/gateways" routerLinkActive="active">{{ 'dashboard_nav_gateways' | translate }}</a>
    }

    <!-- Shared by every role: the page only requires a session, and a cloud
         customer gets the password-only version of it. -->
    @if (isLoggedIn) {
        <a routerLink="/account" routerLinkActive="active">{{ 'dashboard_nav_account_details' | translate }}</a>
    }
</nav>
